module.exports = __webpack_public_path__ + "images/stickers/pete-confused.a0282453d98453f55aa9.png";